import React, { Component } from 'react';
import Loader from './loader.js';
import Form from './form.js';
import './../assets/css/App.css';
import { helpers, getLinkedTable, LinkedRecordID } from './helper.js';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      countryData: [],
      subjectData: [],
      subjectList: [],
      chosenCountryID: null,
      chosenSubject: '',
      chosenSubjectID: '',
      isLoaded: false,
      isDisabled: false
    };

    this.updateSubjectArr = this.updateSubjectArr.bind(this);
  }

  updateSubjectArr(subjects, method, event) {
    let subjectListArr = [];
    let methodtmp = method;

    if (methodtmp === 'ajax') {
      if (subjects.length > 0) {
        subjectListArr = subjects.map(subject => {
          return subject.fields['subject_array'].join();
        });
        this.setState({
          subjectList: subjectListArr
        });
      }
    } else {
      this.setState({
        subjectList: subjects
      });
    }
  }

  componentDidMount() {
    // Load data from countries and subject table
    helpers.getTables('countries', 'subjects').then(data => {
      this.setState({
        countryData: data.countryData,
        subjectData: data.subjectData,
        isLoaded: true
      });

      console.log('table data loaded and assigned to state');
      //update subject state with array of subjects. Pass in ajax method of update
      this.updateSubjectArr(this.state.subjectData, 'ajax');
    });

    getLinkedTable('partner_universities', LinkedRecordID);
  }

  render() {
    return (
      <div className="form-container">
        <div className="panel-body">
          {this.state.isLoaded ? (
            <Form
              subjectList={this.state.subjectList}
              countryData={this.state.countryData}
              subjectData={this.state.subjectData}
              chosenCountry={this.state.chosenCountry}
              updateSubjectArr={this.updateSubjectArr}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js